export const FooterActionTypes = {
  SET_FOOTER_IS_VISIBLE: 'SET_FOOTER_IS_VISIBLE',
  SET_FOOTER_NOT_VISIBLE: 'SET_FOOTER_NOT_VISIBLE',
}
